import { render, staticRenderFns } from "./BaseFilterTabsContent2.vue?vue&type=template&id=15cc4a7c&scoped=true"
import script from "./BaseFilterTabsContent2.vue?vue&type=script&lang=js"
export * from "./BaseFilterTabsContent2.vue?vue&type=script&lang=js"
import style0 from "./BaseFilterTabsContent2.vue?vue&type=style&index=0&id=15cc4a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cc4a7c",
  null
  
)

export default component.exports